// Colour/label lookup for the entities/ `type:` classification —
// `Wiki::Entities::Frontmatter::TYPES` is the Ruby-side source
// of truth for the value set; this is the display-side mirror so
// WikiPageMeta (page view) and WikiPageCard (catalog/list rows) render
// the same badge from one place instead of duplicating the color map.
//
// Colors are deliberately muted and distinct from the amber Synthesis
// badge and the red/error destructive-action tint used elsewhere in the
// app. `project` gets the most muted treatment since it's the most
// common classification and needs the least visual weight.
export interface EntityTypeBadge {
  label: string
  classes: string
}

// Shared pill shape for every entity-type badge — WikiPageMeta and
// WikiPageCard both combine this with `entityTypeBadge(...).classes`
// (the per-type color) and their own layout modifier (shrink-0 /
// self-start).
export const ENTITY_TYPE_BADGE_BASE_CLASSES =
  'inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide border'

const BADGES: Record<string, EntityTypeBadge> = {
  person: { label: 'Person', classes: 'bg-sky-500/15 text-sky-200 border-sky-500/25' },
  org: { label: 'Org', classes: 'bg-violet-500/15 text-violet-200 border-violet-500/25' },
  product: { label: 'Product', classes: 'bg-teal-500/15 text-teal-200 border-teal-500/25' },
  project: { label: 'Project', classes: 'bg-slate-400/15 text-slate-300 border-slate-400/25' },
}

export function entityTypeBadge(entityType: string | null | undefined): EntityTypeBadge | null {
  if (!entityType) return null
  return BADGES[entityType] ?? null
}
